"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Contains properties for table grouping category elements in report.
 *
 * Created by Hayk.Andriasyan on 5/24/2017.
 */
var TableGroupingDto = /** @class */ (function () {
    function TableGroupingDto() {
        this.elements = [];
    }
    return TableGroupingDto;
}());
exports.TableGroupingDto = TableGroupingDto;
//# sourceMappingURL=table-grouping-dto.js.map